import React from "react";
import ContactList from "../Contact/Contact";
import { Wrapper, Developer, Description } from "./Footer.styled";

const Footer = () => {
  return (
    <Wrapper>
      <Developer>
        <p>
          Created by:{" "}
          <a
            href="https://marknizal.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Mark John Allen Nizal
          </a>
        </p>
        <p>Frontend Engineer</p>
      </Developer>
      <Description>
        <p>
          This webpage was made with love to celebrate Realyn's 23rd birthday.
          It's a special gift created to mark this important day and show how
          much she is appreciated. Thanks for visiting!
        </p>
      </Description>
      <ContactList />
    </Wrapper>
  );
};

export default Footer;
